<template>
  <div class="kiosk-welcome" style="flex-direction: column">
    <div class="mt-5">
      <div class="h3 mb-5">
        <div class="mb-4">
        </div>
        <div>
          <span class="font-weight-bold">NO SERVICE AVAILABLE</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {}
</script>



// WEBPACK FOOTER //
// src/components/pages/kiosk/noService.vue